import OrderInvoice
 from './OrderInvoice';

export default OrderInvoice
;